import React from "react";
import { Input } from "@fluentui/react-components";
import { Control, Controller } from "react-hook-form";
import { Field } from "./Field";
import { t } from "../../i18n/i18n";

type ControlledPhoneInputProps = {
  name: any;
  control: Control<any>;
  label: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
};
export const ControlledPhoneInput = ({
  name,
  control,
  label,
  disabled,
  required,
  placeholder,
}: ControlledPhoneInputProps) => {
  const formatToPhoneNumber = (value: string) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 10);
    const parts = [
      cleaned.slice(0, 3),
      cleaned.slice(3, 6),
      cleaned.slice(6, 8),
      cleaned.slice(8, 10),
    ].filter(Boolean);
    return parts.join(" ");
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? t("RequiredField") : false,
        pattern: /^[0-9]+$/,
        minLength: { value: 10, message: t("PhoneNumberMustBe10Digits") },
        maxLength: { value: 10, message: t("PhoneNumberMustBe10Digits") },
      }}
      render={({
        field: { value, onChange },
        fieldState: { error, invalid },
      }) => {
        return (
          <Field
            label={label}
            required={required ?? false}
            validationMessage={error ? error.message : undefined}
            validationState={error ? "error" : undefined}
          >
            <Input
              type="text"
              value={value ? formatToPhoneNumber(value.toString()) : ""}
              onChange={(e, data) => {
                const rawValue = data.value.replace(/\D/g, "")?.slice(0, 10);
                onChange(rawValue);
              }}
              disabled={disabled ?? false}
              placeholder={placeholder}
            />
          </Field>
        );
      }}
    />
  );
};
